/**
 * The brand illustrations an article shows when it has no cover, or its cover fails
 * to load. Deliberately few, and calm: the covers themselves are photographs now,
 * and the fallback should read as a quiet placeholder rather than as artwork.
 */
const FALLBACKS = [
  "/covers/fallback/pulse-morning.svg",
  "/covers/fallback/dna.svg",
  "/covers/fallback/pulse-evening.svg",
] as const;

/** Stable pick from a slug, so an article always looks the same between renders. */
export function fallbackCoverFor(slug: string): string {
  let hash = 0;
  for (let index = 0; index < slug.length; index += 1) {
    hash = (hash * 31 + slug.charCodeAt(index)) | 0;
  }
  return FALLBACKS[Math.abs(hash) % FALLBACKS.length];
}
